// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__378zT","modalForm":"UpgradeEpcsModal_modalForm__3qSRN","modalFooter":"UpgradeEpcsModal_modalFooter__1lvsy"};